<template>
  <v-flex class="item_box pa-0 mt-15">
    <h2 class="m_title">{{ $t('component.application_information.application_information') }}</h2>
    <v-row>
      <v-col cols="12">
        <div class="component_6">
          <table class="table__header__style ty2">
            <colgroup>
              <col width="180px"/>
              <col>
            </colgroup>
            <tbody>
              <tr>
                <td style="min-width:150px;" :class="{ 'nec_title text-left' : !this.$vuetify.rtl, 'nec_title text-right' : this.$vuetify.rtl}">
                  {{ $t('component.application_information.application_no') }}
                </td>
                <td style="word-break:break-all;" :class="{ 'ft-size12 text-left' : !this.$vuetify.rtl, 'ft-size12 text-right' : this.$vuetify.rtl}">
                  <div v-html="application_no.split(',').join(',&nbsp;&nbsp;')"></div>
                  <p v-if="request_service_code === '1005' && !(application_no)" style="color:#a01c2a;font-weight:bold;">({{ application_receipt_no }})</p>
                </td>
              </tr>
              <tr>
                <td :class="{ 'nec_title text-left' : !this.$vuetify.rtl, 'nec_title text-right' : this.$vuetify.rtl}">
                  {{ $t('component.application_information.title') }}
                </td>
                <td style="word-break:break-all;" :class="{ 'ft-size12 text-left' : !this.$vuetify.rtl, 'ft-size12 text-right' : this.$vuetify.rtl}">
                  {{ $vuetify.rtl ? title_ar : title_en }}
                  <v-badge :content="'+'+ (application_cnt - 1)"
                    v-if="application_cnt > 1" class="pl-1 badge__new"
                  ></v-badge>
                </td>
              </tr>
              <tr>
                <td :class="{ 'nec_title text-left' : !this.$vuetify.rtl, 'nec_title text-right' : this.$vuetify.rtl}">
                  {{ $t('component.application_information.applicant') }}
                </td>
                <td style="word-break:break-all;" :class="{ 'ft-size12 text-left' : !this.$vuetify.rtl, 'ft-size12 text-right' : this.$vuetify.rtl}">
                  {{ $vuetify.rtl ? applicant_name_list_ar : applicant_name_list_en }}
                  <v-badge :content="'+'+ (application_cnt - 1)"
                    v-if="application_cnt > 1" class="pl-1 badge__new"
                  ></v-badge>
                </td>
              </tr>
              <tr>
                <td :class="{ 'nec_title text-left' : !this.$vuetify.rtl, 'nec_title text-right' : this.$vuetify.rtl}">
                  {{ $t('component.application_information.requests') }}
                </td>
                <td style="word-break:break-all;" :class="{ 'ft-size12 text-left' : !this.$vuetify.rtl, 'ft-size12 text-right' : this.$vuetify.rtl}">
                  {{ $vuetify.rtl ? request_name_ar : request_name_en }}
                </td>
              </tr>
              <tr v-if="request_date !== ''">
                <td :class="{ 'nec_title text-left' : !this.$vuetify.rtl, 'nec_title text-right' : this.$vuetify.rtl}">
                  {{ $t('component.application_information.submitted_date') }}
                </td>
                <td style="word-break:break-all;" :class="{ 'ft-size12 text-left' : !this.$vuetify.rtl, 'ft-size12 text-right' : this.$vuetify.rtl}">
                  {{ request_date }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
    </v-row>
  </v-flex>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  name: 'LayoutApplicationInformation',
  props : {
    receipt_no: String,
    api_target: String,
  },
  components :{
  },
  data () {
    return {
      request_date : '',
      request_name_ar : '',
      request_name_en : '',
      application_no : '',
      request_service_code: '',
      application_receipt_no: '',
      title_ar : '',
      title_en : '',
      applicant_name_list_ar : '',
      applicant_name_list_en : '',
      application_cnt: 0,
      target : ''
    }
  },
  mounted(){
    this.target = utils.isNull(this.api_target) ? '' : '/' + this.api_target

    this.getApplicationInformation()
  },
  methods: {
    getApplicationInformation(){
      requestApi({
        url: this.target + '/receivings/'+this.receipt_no+'/application',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data){
              this.request_date = res.data.request_date
              this.request_name_ar = res.data.request_name_ar
              this.request_name_en = res.data.request_name_en
              this.application_no = res.data.application_no
              this.request_service_code = res.data.request_service_code
              this.application_receipt_no = res.data.application_receipt_no
              this.title_ar = res.data.title_ar
              this.title_en = res.data.title_en
              this.applicant_name_list_ar = res.data.applicant_name_list_ar
              this.applicant_name_list_en = res.data.applicant_name_list_en
              this.application_cnt = res.data.application_cnt
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getApplicationInformation()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  },
}
</script>